import { Button, Card, Stack, Text } from '@mantine/core';
import type { ReactNode } from 'react';
import { brand } from '@/theme/theme';

/** Generic outline glyph; call sites don't need to pick a per-state icon. No emoji per frontend-design.md §8. */
function DefaultIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
      <rect x="3" y="7" width="18" height="13" rx="2" />
      <path d="M3 7l3-4h12l3 4" strokeLinejoin="round" />
      <path d="M9 11.5v3M15 11.5v3" strokeLinecap="round" />
    </svg>
  );
}

export interface EmptyStateProps {
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void };
  icon?: ReactNode;
}

/** Centred placeholder for a card or page with nothing to show yet. See frontend-design.md §6. */
export function EmptyState({ title, description, action, icon }: EmptyStateProps) {
  return (
    <Card>
      <Stack align="center" gap={8} py="xl">
        <Text c={brand.textMuted} component="div">
          {icon ?? <DefaultIcon />}
        </Text>
        <Text fw={600}>{title}</Text>
        {description && (
          <Text fz={14} c={brand.textMuted} ta="center" maw={360}>
            {description}
          </Text>
        )}
        {action && (
          <Button mt="sm" onClick={action.onClick}>
            {action.label}
          </Button>
        )}
      </Stack>
    </Card>
  );
}
